import React from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import DeviationDumbView from '@wix/da-shared-react/pkg/DeviationViews/Dumbo';
import PreviewThumb, { Props as PreviewThumbProps } from '../PreviewThumb';

interface Props extends PreviewThumbProps {
  item: PapiDeviation;
}

const MainThumb: React.FC<Props> = ({ item, ...props }) => (
  <PreviewThumb {...props}>
    <DeviationDumbView deviation={item} height={56} width={56} />
  </PreviewThumb>
);

MainThumb.displayName = 'MainThumb';

export default MainThumb;
